export default "__VITE_ASSET__F4O15b3b__"